import {
  BASE_VIEW_SCALE,
  MAX_VIEW_SCALE,
  MIN_VIEW_SCALE,
} from '../../constants';

export const ZOOM_PRESETS = [2500, 1000, 400, 200, 100, 50].map((percent) => ({
  label: `${percent}%`,
  scale: BASE_VIEW_SCALE / (percent / 100),
}));

/**
 * The slider runs 0..1 left to right, mapping logarithmically onto the scale
 * range so that every doubling of zoom takes the same amount of travel. 0 is
 * fully zoomed out (MAX_VIEW_SCALE), 1 is fully zoomed in (MIN_VIEW_SCALE).
 */
export const scaleFromSlider = (position: number) =>
  MAX_VIEW_SCALE * (MIN_VIEW_SCALE / MAX_VIEW_SCALE) ** position;

export const sliderFromScale = (scale: number) =>
  Math.log(scale / MAX_VIEW_SCALE) / Math.log(MIN_VIEW_SCALE / MAX_VIEW_SCALE);

export const getZoomPercentage = (scale: number) =>
  Math.round((BASE_VIEW_SCALE / scale) * 100);
